import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import Stat from 'src/components/mui/chip/stat'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import { useGetAllQuery } from '../../store/questionApi'
import TableQuestion from '../../views/question/TableQuestion'

const QuestionList = () => {
  const [total, setTotal] = useState(0);
  const { data, error } = useGetAllQuery({
    refetchOnFocus: true
  });
  
  useEffect(() => {
    data && setTotal(data.data)
  }, [data]);

  return (
    <Page title="Question">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  문의
                </Typography>
                <Stat value={total}/>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              문의 리스트를 보여줍니다.
            </Typography>
          }
        />
        <Grid item xs={12}>
          <TableQuestion />
        </Grid>
      </Grid>
    </Page>
  )
}

export default QuestionList